import React from 'react';
import './About.css';
export default function About() {
  return (
    <>
    <div className='Main-sub-heading-div bordered '>
      <h1 className='Main-sub-heading-div-h1'>
          About Us
      </h1>
      <p> 
        At Fakhar Autos Works, we pride ourselves on delivering 
        top-notch auto repair services. Our team of skilled professionals 
        is dedicated to ensuring your vehicle is in peak condition, 
        providing you peace of mind on the road.
      </p>
    </div>

    <div className='About-detail'>
      <h2 className='About-detail-h2'>
          About Fakhar Autos Workshop
      </h2>
      <p>
        Fakhar Autos Workshop is a reputable automotive service center located in Islamabad, Pakistan, dedicated to providing comprehensive car repair and maintenance solutions. With a team of skilled technicians, the workshop offers a wide array of services to ensure vehicles operate at their optimal performance levels.  The workshop specializes in various aspects of automotive care, including:  <ul>
        <li>Mechanical Repairs: Addressing issues related to the engine, transmission, brakes, and other critical components to ensure the vehicle's reliability and safety.</li>
        <li>Electrical Services: Diagnosing and repairing electrical systems, including battery replacement, alternator repairs, and resolving wiring issues.</li>
        <li>Car Painting: Providing professional painting services to restore or change the vehicle's appearance, ensuring a flawless finish.</li>
        <li>Car Detailing: Offering thorough cleaning and restoration services to maintain the vehicle's interior and exterior aesthetics.</li>
        <li>Dent Removal: Utilizing specialized techniques to remove dents without affecting the original paintwork, preserving the vehicle's value.</li>
        </ul>
        <p>
          Fakhar Autos Workshop prides itself on its commitment to quality workmanship and customer satisfaction. The motto, "From Engine to Exhaust – We Fix It All!", reflects their dedication to handling all types of repairs, whether minor or major. The expert team ensures fast and reliable service, allowing customers to drive with confidence.
        </p>
        <p>
          For those seeking expert car repair and maintenance services in Islamabad, Fakhar Autos Workshop can be reached at:  <br />
          <span className='About-detail-phone'>Phone: +92 335 1908270</span><br />
          <span className='About-detail-email'>Email: info@old.fakharautoworkshop.com</span>
        </p>
      </p>
    </div>
    <style jsx>{`
    
      .about {
      color: #9a0002 !important;

      }
    `}</style>
    </>
  );
}
